/**
 * Mapping for nursing education status i18n keys.
 */
export const getNursingEducationStatusLabelKey = (value: string) => {
  const labels: { [key: string]: string } = {
    not_started: "forms.common.nursing_education.not_started",
    in_progress: "forms.common.nursing_education.in_progress",
    completed: "forms.common.nursing_education.completed",
    not_applicable: "Nicht zutreffend"
  };
  return labels[value] || value;
};

/**
 * Mapping for recognition status i18n keys.
 */
export const getRecognitionStatusLabelKey = (value: string) => {
  const labels: { [key: string]: string } = {
    not_applied: "forms.common.recognition_status.not_applied",
    pending: "forms.common.recognition_status.pending",
    partially_approved: "forms.common.recognition_status.partially_approved",
    approved: "forms.common.recognition_status.approved"
  };
  return labels[value] || value;
};
